

















































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import {部署初期値, 部署型} from '@/type/department/department';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
  },
})

export default class UpdateDepartment extends Vue {

  @Prop({default: false})
  private modal!: boolean;
  @Prop({default: 部署初期値})
  private department!: 部署型;

  private 部署更新: 部署型 = {...this.department};
  private アラートメッセージ: string[] = [];

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.部署更新 = {...this.department};
      this.openDialog('部署マスタ更新画面');
    }
  }

  @Emit('close-form')
  private closeForm(): void {
    this.clear();
    this.closeDialog('部署マスタ更新画面');
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private updateHandler(): void {
    progress(this.update);
  }

  private async update(): Promise<void> {
    if (this.部署更新) {
      await api.部署を更新する(this.部署更新)
        .then(
          () => {
            this.closeDialog('確定ダイアログ');
            this.closeForm();
          },
          (error: any) => {
            this.closeDialog('確定ダイアログ');
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.openDialog('部署更新アラート');
          },
        );
    }
  }

  private clear(): void {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init(): void {
    this.部署更新 = {...this.department};
    this.アラートメッセージ = [];
  }

  private get isStockManager(): boolean {
    return loginModule.システム利用区分が発注と在庫管理である;
  }

  private get isDeleted(): boolean {
    if (this.department === null) {
      return false;
    }
    return this.department.削除フラグ === '削除';
  }

}
